// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__JSsqD","header":"ReportDetails_header__2WeXK","title":"ReportDetails_title__2wBHP","left":"ReportDetails_left__el0eH"};